import React from 'react';
import DefiniteContestResult from "../DefiniteContestResult";
import {GET_CONTEST_INFO_BY_ID} from "../../../../../../AdminPart/GraphQL/queries/OnlyHereQueries";
import {useQuery} from "@apollo/client";

function QueryContestInfoByID (props) {
    const { loading, error, data} = useQuery(GET_CONTEST_INFO_BY_ID, { variables: {ContestID : props.ContestID  } });
    if (loading) return 'Loading All Results...';
    if (error) return `loading error! ${error.message}`;
    if (data.getContestByID.length !==0) {
        return <DefiniteContestResult data={props.data} ContestInfo={data.getContestByID} Prerender_texts = {props.Prerender_texts} lang={props.lang}/>;
    } else {
        return <div/>
    }}
export default QueryContestInfoByID